import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useState } from 'react';
import { RadioGroup } from '../../../Radio/rn/RadioGroup';
import { gray_6 } from '../../../../styles/rn';
export default (function (props) {
  var options = props.options;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];
  var radioGroupProps = {
    value: selectedOption,
    options: options === null || options === void 0 ? void 0 : options.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        containerStyle: {
          paddingVertical: 14,
          paddingHorizontal: 0,
          marginHorizontal: 0,
          marginRight: 0,
          paddingRight: 0,
          borderBottomWidth: 0.5,
          borderBottomColor: gray_6
        },
        textStyle: {
          lineHeight: 16,
          fontSize: 14,
          flex: 1
        }
      });
    }),
    layout: 'vertical',
    onChange: function onChange(val) {
      var _props$onChange;
      setSelectedOption(val);
      (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, val);
    },
    containerStyle: {
      paddingLeft: 12
    }
  };
  return /*#__PURE__*/React.createElement(RadioGroup, _extends({}, radioGroupProps, {
    options: radioGroupProps.options
  }));
});